import {
  Department_Read,
  Department_Read_Nested,
  Department_Read_Typeahead,
} from '@treadinc/horizon-api-spec';
import dayjs, { Dayjs } from 'dayjs';

import { CompanyBasic } from '~hooks/useCompany/models';
import { ItemNameAndId } from '~types/ItemNameAndId';
import { Nullable } from '~types/Nullable';

export class BasicDepartment extends ItemNameAndId {
  public static parse(proto: Department_Read_Nested) {
    return new BasicDepartment(
      proto.id ?? '',
      proto.name ?? '',
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get discardedAt() {
    return this._discarded_at;
  }

  constructor(
    _id: string,
    _name: string,
    private _discarded_at: Dayjs | null = null,
  ) {
    super(_name, _id);
  }
}

export class DepartmentTypeahead extends ItemNameAndId {
  public static parse(proto: Department_Read_Typeahead) {
    return new DepartmentTypeahead(proto.id ?? '', proto.name ?? '');
  }
  constructor(_id: string, _name: string) {
    super(_name, _id);
  }
}

export class Department extends BasicDepartment {
  public static parse(proto: Department_Read) {
    return new Department(
      proto.id ?? '',
      proto.name ?? '',
      proto.company ? CompanyBasic.parse(proto.company) : null,
      dayjs(proto.created_at),
      dayjs(proto.updated_at),
      proto.discarded_at ? dayjs(proto.discarded_at) : null,
    );
  }

  public get company() {
    return this._company;
  }

  public get companyName() {
    return this._company?.legalName || '';
  }

  public get createdAt() {
    return this._createdAt;
  }

  public get updatedAt() {
    return this._updatedAt;
  }

  constructor(
    _id: string,
    _name: string,
    private _company: Nullable<CompanyBasic>,
    private _createdAt: Dayjs,
    private _updatedAt: Dayjs,
    _discarded_at: Dayjs | null = null,
  ) {
    super(_id, _name, _discarded_at);
  }
}
